(() => {
  const status = document.getElementById('CartStatus');
  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'INR',
      maximumFractionDigits: 0
    }).format((Number(cents) || 0) / 100);

  const announce = (text) => {
    if (!status) return;
    status.textContent = text;
    status.classList.add('is-visible');
    window.setTimeout(() => status.classList.remove('is-visible'), 3500);
  };

  const setCartCount = (count) =>
    document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach((el) => {
      el.textContent = count;
    });

  const drawer = document.getElementById('CartDrawer');
  const linesEl = drawer?.querySelector('[data-cart-drawer-lines]');
  const emptyEl = drawer?.querySelector('[data-cart-drawer-empty]');
  const filledEl = drawer?.querySelector('[data-cart-drawer-filled]');
  const footEl = drawer?.querySelector('[data-cart-drawer-foot]');
  const totalEl = drawer?.querySelector('[data-cart-drawer-total]');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('cart-drawer-open');
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('cart-drawer-open');
  };

  const renderDrawer = (cart) => {
    if (!drawer) return;
    setCartCount(cart.item_count);

    const compareEl = drawer.querySelector('[data-cart-drawer-compare]');
    const discountNote = drawer.querySelector('[data-cart-drawer-discount-note]');
    const originalTotal = Number(cart.original_total_price) || 0;
    const finalTotal = Number(cart.total_price) || 0;
    const cartDiscount = Math.max(0, originalTotal - finalTotal);

    if (totalEl) totalEl.textContent = money(finalTotal);
    if (compareEl) {
      if (cartDiscount > 0) {
        compareEl.hidden = false;
        compareEl.textContent = money(originalTotal);
      } else {
        compareEl.hidden = true;
        compareEl.textContent = '';
      }
    }
    if (discountNote) {
      if (cartDiscount > 0) {
        discountNote.hidden = false;
        discountNote.textContent = `Offer applied · You save ${money(cartDiscount)}`;
      } else {
        discountNote.hidden = true;
        discountNote.textContent = '';
      }
    }

    const empty = !cart.item_count;
    if (emptyEl) emptyEl.hidden = !empty;
    if (filledEl) filledEl.hidden = empty;
    if (footEl) footEl.hidden = empty;

    if (linesEl) {
      linesEl.innerHTML = (cart.items || [])
        .map((item) => {
          const original = Number(item.original_line_price) || 0;
          const final = Number(item.final_line_price) || 0;
          const showStrike = original > final;
          const priceHtml = showStrike
            ? `<p class="cart-drawer__price"><s>${money(original)}</s> <strong>${money(final)}</strong></p>`
            : `<p class="cart-drawer__price">${money(final)}</p>`;
          return `
        <div class="cart-drawer__line">
          ${
            item.image
              ? `<a href="${item.url}"><img src="${item.image}" alt="" width="72" height="72" loading="lazy"></a>`
              : ''
          }
          <div>
            <a href="${item.url}">${item.product_title}</a>
            ${priceHtml}
            <div class="cart-drawer__qty">
              <button type="button" data-cart-change="${item.key}" data-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
              <button type="button" class="cart-drawer__remove" data-cart-change="${item.key}" data-qty="0" aria-label="Remove">Remove</button>
            </div>
          </div>
        </div>`;
        })
        .join('');
    }

    document.querySelectorAll('[data-offer-product-id]').forEach((card) => {
      const id = Number(card.getAttribute('data-offer-product-id'));
      const inCart = (cart.items || []).some((item) => item.product_id === id);
      card.hidden = inCart;
    });
  };

  async function refreshCart() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    renderDrawer(cart);
    return cart;
  }

  async function addItem(id, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
    });
    if (!response.ok) throw new Error('Unable to add this formulation.');
    const cart = await refreshCart();
    announce('Added to your bag.');
    openDrawer();
    return cart;
  }

  async function changeQty(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    });
    if (!response.ok) throw new Error('Unable to update cart.');
    return refreshCart();
  }

  document.addEventListener('click', async (event) => {
    const menu = event.target.closest('[data-menu-toggle]');
    if (menu) {
      const nav = document.getElementById(menu.getAttribute('aria-controls'));
      if (!nav) return;
      const open = nav.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', open);
    }

    const openChat = event.target.closest('[data-open-concierge]');
    if (openChat) {
      event.preventDefault();
      const launcher = document.querySelector('.aviva-concierge__launcher');
      if (launcher) launcher.click();
      return;
    }

    const thumb = event.target.closest('[data-media-url]');
    if (thumb) {
      const main = document.getElementById('ProductMainImage');
      if (main) {
        main.src = thumb.dataset.mediaUrl;
        main.srcset = '';
      }
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    const bagLink = event.target.closest('[data-cart-link]');
    if (bagLink && drawer) {
      event.preventDefault();
      await refreshCart();
      openDrawer();
      return;
    }

    const changeBtn = event.target.closest('[data-cart-change]');
    if (changeBtn) {
      try {
        await changeQty(changeBtn.getAttribute('data-cart-change'), changeBtn.getAttribute('data-qty'));
      } catch (error) {
        announce(error.message);
      }
      return;
    }

    const applyCoupon = event.target.closest('[data-drawer-apply-coupon]');
    if (applyCoupon) {
      const input = document.querySelector('[data-drawer-coupon]');
      const code = (input?.value || '').trim();
      if (!code) {
        input?.focus();
        return;
      }
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const data = new FormData(form);
    const button = event.submitter || form.querySelector('[type="submit"]') || document.querySelector(`button[form="${form.id}"]`);
    if (button) button.disabled = true;
    try {
      await addItem(data.get('id'), Number(data.get('quantity') || 1));
    } catch (error) {
      announce(error.message);
    } finally {
      if (button) button.disabled = false;
    }
  });

  const ritual = document.querySelector('[data-rituals]');
  if (ritual) {
    const total = ritual.querySelector('[data-ritual-total]');
    const items = () => [...ritual.querySelectorAll('[data-ritual-item]:checked')];
    const update = () => {
      if (!total) return;
      const amount = items().reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
      total.textContent = money(amount);
    };
    ritual.addEventListener('change', update);
    update();
    ritual.querySelector('[data-ritual-add]')?.addEventListener('click', async () => {
      const selected = items();
      if (!selected.length) return announce('Select at least one ritual step.');
      try {
        for (const item of selected) await addItem(item.value);
        announce('Your ritual has been added.');
      } catch (error) {
        announce(error.message);
      }
    });
    ritual.querySelector('[data-quiz-submit]')?.addEventListener('click', () => {
      const unanswered = [...ritual.querySelectorAll('[data-quiz-question]')].some(
        (question) => !question.querySelector(':checked')
      );
      if (unanswered) return announce('Please answer each ritual question.');
      const result = ritual.querySelector('[data-quiz-result]');
      result.hidden = false;
      result.textContent =
        'Your prescribed protocol is ready. Explore the selected ritual steps above, then add them to your sanctuary bag.';
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

})();
